import actions from './actions';
import getters from './getters';

export { namespace } from './types/index';

const namespaced = true;

export const module = {
  namespaced,
  actions,
  getters
};
